import script from "./LoginRegisterMixin.vue?vue&type=script&lang=ts"
export * from "./LoginRegisterMixin.vue?vue&type=script&lang=ts"

export default script